import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextBlock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTextBlock"><Path d="M12 4.5V6H21V4.5H12Z" fill="currentColor"/><Path d="M12 8V9.5H18V8H12Z" fill="currentColor"/><Path d="M12 14.5V16H21V14.5H12Z" fill="currentColor"/><Path d="M12 18V19.5H18V18H12Z" fill="currentColor"/><Path d="M3 4V10H9V4H3Z" fill="currentColor"/><Path d="M3 14V20H9V14H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextBlock;
